import { Typography, Button, Markdown } from '@mgmresorts/wcl-lab';
import { styled } from '@mgmresorts/wcl-styled';
import React from 'react';

import { Container } from './Container';
import { Logo } from './Logo';
import { PageLayout } from './PageLayout';
import { RadioCheck } from './icons/RadioCheck';

const StyledContent = styled.div`
  .identity__confirmation-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    margin-top: 16px;
  }

  .identity__confirmation-wrapper {
    h1,
    h2,
    h3 {
      text-align: center;
    }
  }

  .identity__confirmation-description {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #606060;
    margin-top: 8px;
    margin-bottom: 32px;
  }

  .identity__confirmation-logo {
    align-self: center;
    margin-bottom: 32px;
  }
`;

interface ConfirmationProps {
  title: string;
  description: string;
  redirectCTA?: {
    label: string;
    action: () => Promise<void> | void;
  };
  testId?: string;
  icon?: React.ReactNode;
  noIcon?: boolean;
}

export const Confirmation = ({ title, description, redirectCTA, icon, noIcon, testId }: ConfirmationProps) => {
  return (
    <StyledContent>
      <PageLayout title={title} testId={testId}>
        <Container height='auto'>
          <Logo className='identity__confirmation-logo' />

          {!noIcon && (icon || <RadioCheck />)}

          {/** TODO
           * The Typography lab component is not correctly passing testId on the `h` variants
           * - while it is on the other variants - but it accepts data-testid -
           * To be changed to the correct testId
           * */}
          <Typography variant='h5' className='identity__confirmation-title' as='h1' data-testid='confirmation-title'>
            {title}
          </Typography>

          <Markdown
            className='identity__confirmation-wrapper'
            paragraphProps={{ className: 'identity__confirmation-description' }}
            testId='confirmation-description'
          >
            {description}
          </Markdown>

          {redirectCTA ? (
            <Button
              sticky
              testId='confirmation-cta'
              ariaLabel={redirectCTA.label}
              onClick={async () => {
                await redirectCTA.action();
              }}
              onKeyPress={async e => {
                e.preventDefault();
                if (e.key === 'Enter') {
                  await redirectCTA.action();
                }
              }}
              className='identity__form-submit'
            >
              <Typography>{redirectCTA.label}</Typography>
            </Button>
          ) : null}
        </Container>
      </PageLayout>
    </StyledContent>
  );
};

Confirmation.displayName = 'Confirmation';
